import type { CSSProperties, ReactNode } from 'react';

/**
 * AI 身份胶囊（design-spec §4/§5）：
 * 紫蓝 12% 半透明底 + 同色系文字 + 细描边，语义 = 「这是 AI 在做」。
 * 用于机器人会话标识/意图标签/AI 建议徽标等；人/业务元素禁用（保持青蓝）。
 *
 * size="sm" = 密集行/表格内小号（高 20 / 字号 11）：各页原先逐处内联
 * `style={{ height: 20, padding: '0 7px', fontSize: 11 }}` 覆盖尺寸，改由本组件单点承载。
 * 尺寸用内联样式而非类：`.bcc-pill-sm` 在 styles/components.css 中定义于 `.bcc-ai-badge` 之前，
 * 同权重下后者会覆盖前者（复用不生效），而新增 `.bcc-aibadge-sm` 需改该全局文件。
 */
const SM_STYLE: CSSProperties = { height: 20, padding: '0 7px', fontSize: 11 };

export default function AiBadge({
  size,
  children,
  style,
}: {
  /** 尺寸变体：sm=密集行/表格内小号 */
  size?: 'sm';
  children?: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <span className="bcc-ai-badge" style={size === 'sm' ? { ...SM_STYLE, ...style } : style}>
      {children}
    </span>
  );
}
